import {
  CLINICAL_MAPPING,
  NON_CLINICAL_MAPPING,
  QI_CRITERIA_CODES,
  QUALITY_INDICATOR_SEPARATOR
} from "../constants/criteriaModal";

export const divideCalculation = (a?: string | number, b?: string | number): number => {
  // Nếu thiếu 1 trong 2 tham số
  if (!a || !b) return 0;

  const numerator = typeof a === "number" ? a : Number.parseFloat(a);
  const denominator = typeof b === "number" ? b : Number.parseFloat(b);

  // Nếu không phải số hoặc chia cho 0 thì trả về 0
  if (Number.isNaN(numerator) || Number.isNaN(denominator) || denominator === 0) {
    return 0;
  }

  return numerator / denominator;
}

export const multiplicationCalculation = (a?: string | number, b?: string | number): number => {
  // Nếu thiếu 1 trong 2 tham số
  if (!a || !b) return 0;

  const numerator = typeof a === "number" ? a : Number.parseFloat(a);
  const denominator = typeof b === "number" ? b : Number.parseFloat(b);

  // Nếu không phải số hoặc chia cho 0 thì trả về 0
  if (Number.isNaN(numerator) || Number.isNaN(denominator) || denominator === 0) {
    return 0;
  }

  return numerator * denominator;
}

export const plusCalculation = (arr: (string | number)[]): number => {
  return arr.reduce((total: number, value) => {
    const num = typeof value === "number" ? value : Number.parseFloat(value);
    return total + (Number.isNaN(num) ? 0 : num);
  }, 0);
}

export const convertPayload = (dataTable: any[], criteria: any) => {

  return dataTable?.map((item: any) => {
    const clinicalIncidents = pickByMapping(item, CLINICAL_MAPPING);
    const nonClinicalIncidents = pickByMapping(item, NON_CLINICAL_MAPPING);

    return {
      ...criteria,
      id: item?.id,
      criteriaSubsectionId: item?.criteriaId,
      planCriteriaId: criteria?.planId,
      fileId: item?.evidence?.id,
      fileName: item?.evidence?.name,
      resultDepartment: item?.resultDepartment,
      result: item?.result?.id,
      comment: item?.comment,
      status: item?.status,
      numerator: item.numerator,
      denominator: item.denominator,
      clinicalIncidents: QI_CRITERIA_CODES.CLINICAL_INCIDENT === criteria?.chapterCode
        ? buildIncident(clinicalIncidents, CLINICAL_MAPPING)
      : "",
      nonClinicalIncidents: QI_CRITERIA_CODES.NON_CLINICAL_INCIDENT === criteria?.chapterCode
        ? buildIncident(nonClinicalIncidents, NON_CLINICAL_MAPPING)
      : "",
      pointSelfAssessment: criteria?.pointSelfAssessment,
      pointUnitAssessment: criteria?.pointUnitAssessment,
      pointInspectorAssessment: criteria?.pointInspectorAssessment,
      conclusionAssessment: criteria?.conclusionAssessment,
    };
  })
}

export const convertDetailQI = (item: any) => {
  const clinicalIncidents = item?.clinicalIncidents
    ? parseIncident(item?.clinicalIncidents, CLINICAL_MAPPING)
    : {};
  const nonClinicalIncidents = item?.nonClinicalIncidents
    ? parseIncident(item?.nonClinicalIncidents, NON_CLINICAL_MAPPING)
    : {};

  console.log("convert", item);
  return {
    ...item,
    ...clinicalIncidents,
    ...nonClinicalIncidents,
  };
};

export const pickByMapping = <T extends Record<string, any>>(
  source: T,
  mapping: Record<number, string>
) => {
  return Object.values(mapping).reduce((acc, field) => {
    acc[field] = source[field] ?? 0;
    return acc;
  }, {} as Record<string, number>);
};

export const parseIncident = (
  str: string = "",
  mapping: Record<number, string> = {},
  separator = QUALITY_INDICATOR_SEPARATOR
) => {
  const arr = str.split(separator);

  return Object.entries(mapping).reduce((acc, [index, field]) => {
    acc[field] = Number(arr[Number(index)] ?? 0);
    return acc;
  }, {} as Record<string, number>);
};

export const buildIncident = (
  data: Record<string, number>,
  mapping: Record<number, string>,
  separator = QUALITY_INDICATOR_SEPARATOR
) => {
  const maxIndex = Math.max(...Object.keys(mapping).map(Number));

  const arr = new Array(maxIndex + 1).fill(0);

  Object.entries(mapping).forEach(([index, field]) => {
    arr[Number(index)] = data[field] ?? 0;
  });

  return arr.join(separator);
};
